/**
 * מיפוי מפתח מטריצה (Backend feature_key) ↔ שדה ב־buildEntitlementSelectors.
 * null = אין בוליאן ייעודי (למשל commission — ערך מספרי בלבד).
 */
export const ENTITLEMENT_FEATURE_KEY_TO_SELECTOR_PROP = {
  search_hotels: "canSearchHotels",
  search_packages: "canSearchPackages",
  search_flights: "canSearchFlights",
  dynamic_packages: "canUseDynamicPackages",
  organized_tours: "canOrganizedTours",
  priority_support: "hasPrioritySupport",
  leads_system: "canUseLeadsSystem",
  seo_system: "canUseSeoSystem",
  smart_quotes: "canUseSmartQuotes",
  crazy_llama: "canUseAiSales",
  hotel_prebooking: "canUseHotelPrebooking",
  team_management: "canUseTeamManagement",
  referral_rewards: "canUseReferralRewards",
  monthly_pricing: "canUseMonthlyPricing",
  customer_offer_link: "canUseCustomerOfferLink",
  multi_package_customer_offer: "canUseMultiPackageCustomerOffer",
  billing_access: "canViewBillingSummary",
  agent_public_site: "canUseAgentPublicSite",
  mano_quotes: "canUseManoQuotes",
};

/**
 * @param {Record<string, unknown>} selectors — פלט buildEntitlementSelectors
 * @param {string} featureKey
 * @returns {boolean|null} null אם אין מיפוי — אל תשתמש ב-fail-open
 */
export function canUseEntitlementFeatureKey(selectors, featureKey) {
  const k = String(featureKey || "").trim();
  const prop = ENTITLEMENT_FEATURE_KEY_TO_SELECTOR_PROP[k];
  if (!prop) return null;
  return Boolean(selectors[prop]);
}
